function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogo3 = function SvgLogo3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "97px",
    height: "83px",
    viewBox: "0 0 97 83",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-25.2,-301.499)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.62,255.96L271.62,113.69L148.41,42.55L25.2,113.69L25.2,255.96L148.41,327.09L271.62,255.96Z",
    style: {
      fill: "rgb(230,230,230)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.01,312.87L309.01,170.6L185.8,99.46L62.59,170.6L62.59,312.87L185.8,384L309.01,312.87Z",
    style: {
      fill: "rgb(204,204,204)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.83,49.08C190.83,49.08 197.35,57.62 197.33,70.19L197.33,73.44L173.23,73.44C173.63,77.5 176.39,80.99 181.83,81C184.835,80.942 187.703,79.723 189.83,77.6L195.02,84.66C191.36,88.39 185.68,90.25 180.41,90.24C169.05,90.24 161.41,82.11 161.41,69.62C161.48,58.23 168.47,49.07 179.83,49.08ZM173.16,65.54L186.16,65.54C186,62.37 184.55,58.31 179.68,58.31C175,58.32 173.41,62.38 173.16,65.54Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.8,35.15L214.56,35.15L214.51,89.27L202.74,89.27L202.8,35.15Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.64,49.14C249.64,49.14 256.16,57.68 256.15,70.25L256.15,73.5L232.06,73.5C232.46,77.56 235.21,81.05 240.65,81.06C243.654,80.997 246.52,79.779 248.65,77.66L253.83,84.72C250.18,88.45 244.49,90.31 239.22,90.3C227.86,90.3 220.22,82.17 220.22,69.68C220.3,58.29 227.29,49.13 238.64,49.14ZM232,65.6L245,65.6C244.84,62.43 243.38,58.37 238.51,58.37C233.77,58.38 232.22,62.44 232,65.6Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.23,49.18C284.8,49.18 289.23,51.87 291.37,54.55L285.68,62.55C284.243,60.647 281.985,59.533 279.6,59.55C274.81,59.55 271.6,63.55 271.6,69.68C271.6,75.81 274.83,79.91 279.6,79.91C282.007,79.931 284.281,78.782 285.69,76.83L291.34,85C289.23,87.68 284.76,90.35 278.19,90.34C267.19,90.34 259.54,81.89 259.55,69.72C259.56,57.55 267.2,49.17 278.23,49.18Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.16,79.22L298.16,60.4L293.21,60.4L293.21,50.17L298.16,50.17L298.16,39.47L310,39.47L310,50.19L316.33,50.19L316.33,60.42L310,60.42L310,76.32C310,78.59 310.89,79.97 312.68,79.98C313.647,80.011 314.595,79.695 315.35,79.09L317.46,88.17C315.99,89.39 313.15,90.36 309.34,90.36C301.71,90.34 298.15,86.6 298.16,79.22Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.91,38.43C320.937,34.73 323.989,31.7 327.69,31.7C331.409,31.7 334.47,34.761 334.47,38.48C334.47,42.188 331.428,45.243 327.72,45.26C327.717,45.26 327.713,45.26 327.71,45.26C323.98,45.26 320.91,42.19 320.91,38.46C320.91,38.45 320.91,38.44 320.91,38.43ZM321.79,50.2L333.56,50.2L333.56,89.39L321.75,89.39L321.79,50.2Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.29,69.77C339.29,58.82 345.72,49.25 357.89,49.26C370.06,49.27 376.54,58.85 376.53,69.81C376.52,80.77 370,90.41 357.85,90.4C345.7,90.39 339.28,80.72 339.29,69.77ZM364.45,69.77C364.45,64.09 362.45,59.62 357.88,59.62C353.31,59.62 351.39,64.07 351.38,69.75C351.37,75.43 353.4,80 357.86,80C362.32,80 364.44,75.56 364.45,69.8L364.45,69.77Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.69,64.73C404.69,61.16 402.99,59.73 400.15,59.73C397.31,59.73 395.2,61.83 394.06,63.86L394.06,89.5L382.27,89.5L382.27,50.31L394.03,50.31L394.03,55.18C396.726,51.518 401.012,49.351 405.56,49.35C413.1,49.35 416.42,53.82 416.42,60.15L416.42,89.52L404.66,89.52L404.69,64.73Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.83,134.42C185.83,130.85 184.13,129.42 181.29,129.42C178.45,129.42 176.34,131.53 175.2,133.56L175.2,159.19L163.41,159.19L163.41,120L175.17,120L175.17,124.86C177.871,121.179 182.174,119 186.74,119C194.28,119 197.6,123.48 197.6,129.81L197.6,159.17L185.8,159.17L185.83,134.42Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.51,108.23C204.507,108.143 204.505,108.056 204.505,107.97C204.505,104.25 207.566,101.19 211.285,101.19C215.004,101.19 218.065,104.25 218.065,107.97C218.065,108.056 218.063,108.143 218.06,108.23C218.063,108.317 218.065,108.404 218.065,108.49C218.065,112.21 215.004,115.27 211.285,115.27C207.566,115.27 204.505,112.21 204.505,108.49C204.505,108.404 204.507,108.317 204.51,108.23ZM205.39,120L217.16,120L217.16,159.18L205.35,159.18L205.39,120Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229,161.24C231.634,163.906 235.253,165.375 239,165.3C242.9,165.3 247.2,163.3 247.21,156.79L247.21,152.79C244.69,156.68 241.21,158.46 237.55,158.46C228.79,158.46 222.87,151.79 222.89,138.73C222.89,125.99 228.75,119.02 237.59,119.03C241.572,119.037 245.258,121.177 247.24,124.63L247.24,120L258.93,120L258.93,156.51C258.93,171.51 248.53,175.08 239.6,175.07C233.6,175.07 228.73,173.6 224.52,169.94L229,161.24ZM247.24,133C246.081,130.919 243.937,129.568 241.56,129.42C237.26,129.42 234.91,132.83 234.9,138.75C234.89,144.67 237.25,148.16 241.55,148.17C243.949,148.032 246.108,146.645 247.23,144.52L247.24,133Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.26,134.36C289.26,130.79 287.56,129.49 284.64,129.49C281.72,129.49 279.69,131.59 278.55,133.62L278.55,159.26L266.84,159.26L266.9,105.14L278.58,105.14L278.58,124.94C281.31,121.275 285.62,119.111 290.19,119.11C297.73,119.11 300.97,123.42 300.97,129.75L300.97,159.28L289.24,159.28L289.26,134.36Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.74,149.15L310.74,130.33L305.79,130.33L305.79,120.1L310.74,120.1L310.74,109.4L322.51,109.4L322.51,120.11L328.83,120.11L328.83,130.34L322.5,130.34L322.5,146.24C322.5,148.51 323.39,149.89 325.17,149.89C326.142,149.929 327.095,149.612 327.85,149L329.95,158.09C328.49,159.31 325.65,160.28 321.84,160.28C314.3,160.27 310.73,156.53 310.74,149.15Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.5,178.1C162.497,178.013 162.495,177.926 162.495,177.84C162.495,174.12 165.556,171.06 169.275,171.06C172.994,171.06 176.055,174.12 176.055,177.84C176.055,177.926 176.053,178.013 176.05,178.1C176.053,178.187 176.055,178.274 176.055,178.36C176.055,182.08 172.994,185.14 169.275,185.14C165.556,185.14 162.495,182.08 162.495,178.36C162.495,178.274 162.497,178.187 162.5,178.1ZM163.38,189.87L175.14,189.87L175.14,229.06L163.38,229.06L163.38,189.87Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.31,204.35C205.31,200.78 203.61,199.35 200.77,199.35C197.93,199.35 195.77,201.45 194.68,203.48L194.68,229.12L182.92,229.12L182.92,189.94L194.68,189.94L194.68,194.81C197.371,191.147 201.655,188.979 206.2,188.98C213.75,188.98 217.07,193.45 217.07,199.78L217.07,229.15L205.28,229.15L205.31,204.35Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.79,219L226.79,200.18L221.84,200.18L221.84,189.93L226.79,189.93L226.79,179.22L238.55,179.22L238.55,189.92L244.88,189.92L244.88,200.14L238.55,200.14L238.55,216.04C238.55,218.31 239.43,219.69 241.22,219.69C242.191,219.724 243.142,219.408 243.9,218.8L246,227.89C244.54,229.11 241.7,230.08 237.88,230.07C230.35,230.1 226.78,226.36 226.79,219Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.73,189C277.73,189 284.25,197.54 284.24,210.11L284.24,213.36L260.15,213.36C260.55,217.42 263.3,220.91 268.74,220.92C271.744,220.857 274.61,219.639 276.74,217.52L281.93,224.58C278.27,228.31 272.59,230.17 267.32,230.16C255.96,230.16 248.32,222.03 248.32,209.54C248.39,198.15 255.37,189 266.73,189ZM260.06,205.46L273.06,205.46C272.9,202.29 271.45,198.23 266.58,198.23C261.86,198.24 260.31,202.3 260.06,205.46Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.7,231.22C296.351,233.899 299.993,235.369 303.76,235.28C307.65,235.28 311.95,233.28 311.96,226.77L311.96,222.77C309.44,226.66 305.96,228.44 302.3,228.44C293.53,228.44 287.62,221.77 287.63,208.71C287.63,195.97 293.49,189 302.34,189.01C306.32,189.015 310.005,191.155 311.98,194.61L311.98,190L323.66,190L323.66,226.51C323.66,241.51 313.26,245.08 304.34,245.07C298.34,245.07 293.47,243.6 289.25,239.94L293.7,231.22ZM312,203C310.847,200.915 308.698,199.565 306.32,199.43C302.02,199.43 299.66,202.83 299.66,208.75C299.66,214.67 302,218.16 306.3,218.17C308.701,218.038 310.862,216.649 311.98,214.52L312,203Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.55,190L343.31,190L343.31,195C345.31,191.76 349.88,189 353.78,189L353.78,200.36C352.957,200.145 352.111,200.034 351.26,200.03C348.146,200.085 345.217,201.545 343.3,204L343.3,229.23L331.51,229.23L331.55,190Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.84,178.3C357.837,178.213 357.835,178.126 357.835,178.04C357.835,174.32 360.896,171.26 364.615,171.26C368.334,171.26 371.395,174.32 371.395,178.04C371.395,178.126 371.393,178.213 371.39,178.3C371.393,178.387 371.395,178.474 371.395,178.56C371.395,182.28 368.334,185.34 364.615,185.34C360.896,185.34 357.835,182.28 357.835,178.56C357.835,178.474 357.837,178.387 357.84,178.3ZM358.72,190.07L370.49,190.07L370.49,229.26L358.72,229.26L358.72,190.07Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.19,219.13L380.19,200.31L375.24,200.31L375.24,190.08L380.24,190.08L380.24,179.38L392,179.38L392,190.1L398.32,190.1L398.32,200.32L392,200.32L392,216.23C392,218.5 392.89,219.88 394.67,219.88C395.642,219.919 396.595,219.602 397.35,218.99L399.45,228.08C397.99,229.29 395.15,230.26 391.33,230.26C383.75,230.25 380.18,226.52 380.19,219.13Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.76,234.82C409.76,234.82 411.25,234.17 411.82,232.55L412.71,230.04L399.45,190.11L411.86,190.11L418.73,215.19L425.81,190.13L438.23,190.13L423.01,235.13C420.32,243.13 415.62,245.13 408.64,245.18C406.916,245.173 405.199,244.952 403.53,244.52L405.16,234.22C405.961,234.638 406.856,234.845 407.76,234.82Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.25,313.9L163.31,259.78L175.07,259.78L175.07,264.4C177.056,260.948 180.747,258.812 184.73,258.81C193.57,258.81 199.4,266.29 199.39,279.35C199.39,292.25 193.53,299.95 184.68,299.95C180.695,299.956 177.004,297.807 175.04,294.34L175.04,313.89L163.25,313.9ZM180.74,269.21C178.352,269.312 176.188,270.672 175.06,272.78L175.06,285.92C176.209,288.022 178.351,289.402 180.74,289.58C185.04,289.58 187.4,285.45 187.4,279.36C187.4,273.27 185,269.22 180.74,269.21Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.17,259.83L216.93,259.83L216.93,264.83C218.93,261.58 223.5,258.83 227.4,258.83L227.4,270.18C226.576,269.974 225.73,269.867 224.88,269.86C221.766,269.879 218.823,271.307 216.88,273.74L216.88,298.97L205.13,298.97L205.17,259.83Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.29,279.4C230.29,268.45 236.72,258.88 248.89,258.9C261.06,258.92 267.54,268.49 267.53,279.44C267.52,290.39 261,300 248.85,300C236.7,300 230.28,290.36 230.29,279.4ZM255.44,279.4C255.44,273.72 253.44,269.26 248.88,269.25C244.32,269.24 242.39,273.71 242.38,279.39C242.37,285.07 244.38,289.61 248.86,289.62C253.34,289.63 255.44,285.19 255.44,279.43L255.44,279.4Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285,300.23C285,309.23 280.77,314.99 271.52,314.98C270.237,315.021 268.955,314.883 267.71,314.57L268.04,304.92C268.551,304.982 269.065,305.009 269.58,305C271.85,305 273.24,303.63 273.24,300.22L273.24,259.9L285,259.9L285,300.23ZM272.4,248.13C272.397,248.043 272.395,247.956 272.395,247.87C272.395,244.15 275.456,241.09 279.175,241.09C282.894,241.09 285.955,244.15 285.955,247.87C285.955,247.956 285.953,248.043 285.95,248.13C285.953,248.217 285.955,248.304 285.955,248.39C285.955,252.11 282.894,255.17 279.175,255.17C275.456,255.17 272.395,252.11 272.395,248.39C272.395,248.304 272.397,248.217 272.4,248.13Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.17,259C320.17,259 326.68,267.54 326.67,280.11L326.67,283.36L302.57,283.36C302.97,287.42 305.73,290.91 311.16,290.92C314.163,290.855 317.029,289.637 319.16,287.52L324.35,294.58C320.69,298.31 315.01,300.17 309.74,300.16C298.38,300.16 290.74,292.03 290.74,279.54C290.82,268.11 297.81,259 309.17,259ZM302.5,275.46L315.5,275.46C315.34,272.3 313.89,268.24 309.02,268.24C304.29,268.2 302.75,272.26 302.5,275.42L302.5,275.46Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.76,259C355.33,259 359.76,261.69 361.89,264.37L356.21,272.37C354.77,270.47 352.514,269.357 350.13,269.37C345.34,269.37 342.13,273.37 342.08,279.5C342.03,285.63 345.32,289.72 350.08,289.73C352.488,289.755 354.763,288.604 356.17,286.65L361.84,294.77C359.73,297.45 355.27,300.12 348.7,300.11C337.7,300.11 330.04,291.66 330.06,279.49C330.08,267.32 337.72,259 348.76,259Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.234177,0,0,0.234177,19.2987,294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.68,289L368.68,270.18L363.73,270.18L363.73,260L368.68,260L368.68,249.28L380.45,249.28L380.45,259.99L386.78,259.99L386.78,270.21L380.45,270.21L380.45,286.11C380.45,288.38 381.34,289.76 383.12,289.76C384.092,289.799 385.045,289.482 385.8,288.87L387.9,297.96C386.44,299.18 383.6,300.15 379.78,300.14C372.24,300.16 368.67,296.42 368.68,289Z",
    style: {
      fillRule: "nonzero"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo3.fa7d02d1.svg";
export { ForwardRef as ReactComponent };